import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/combo-products`, {params})
    },
    get(id) {
        return Vue.axios.get(`/combo-products/${id}`)
    },
    create(params) {
        return Vue.axios.post(`/combo-products`, params)
    },
    update(id, params) {
        return Vue.axios.post(`/combo-products/${id}`, {...params, ...{'_method': 'patch'}})
    },
    remove(id){
        return Vue.axios.post(`/combo-products/${id}`, {'_method': 'delete'})
    },
}
